var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"park-openinghours"},[(_vm.isOpen)?_c('p',{staticClass:"text-success"},[_vm._v(" "+_vm._s(_vm.msg)+" "+_vm._s(_vm.nextTime)+" ")]):_vm._e(),(!_vm.isOpen)?_c('p',[_c('span',{staticClass:"park-is-closed"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "+_vm._s(_vm.msg2)+" "+_vm._s(_vm.nextTime)+". ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }